import { httpPost, httpPostFile, httpDownload, httpGet } from '../../../utils/api.utils';
import { getLocalTimeZone, convertToFormatTimeZoneDate } from '../../../utils/helpers.utils';
import { DEFAULT_TABLE_RESULT_MODEL, DEFAULT_TABLE_RESULT_EQUIPMENT_DROPDOWN_MODEL, REPORT_COLUMN_MODULE } from '../../../constants/external-constants';
import { actions } from 'react-redux-form';

import {
    getEquipmentdropDownList,
    getInventoryEquipmentComments,
    getInventoryEquipment,
    setInventoryEquipmentError,
    setInventoryEquipmentColSearchStr,
    sortInventoryEquipmentItems,
    setInventoryEquipmentPageSize,
    setInventoryEquipmentFilter,
    applyInventoryEquipmentFilter,
    getInventoryEquipmentDetailsById,
    inventoryEquipmentModel,
    setFormSubmitted,
    setDefaultInventoryEquipment,
    resetInventoryEquipmentData,
    setVendorsLoading,
    getAllVendors,
    setCircuitTypeLoading,
    getAllCircuitTypes,
    setContractsLoading,
    getAllContracts,
    setGlCodesLoading,
    getAllGlCodes,
    setCostCentersLoading,
    getAllCostCenters,
    setCompanyCodesLoading,
    getAllCompanyCodes,
    setEquipmentDropdownError,
    insertEquipmentComments,
    resetEquipmentComments,
} from '../../../constants/model-reducers/external/inventory/circuit-details/equipment.settings';

export const equipmentInitialState = inventoryEquipmentModel;

const defaultState = () => ({
    isInventoryEquipmentLoaded: false,
    isEquipmentdropDownListLoaded: false,
    isInventoryEquipmentError: false,
    inventoryEquipmentItems: DEFAULT_TABLE_RESULT_MODEL,
    inventoryEquipmentColSort: '',
    inventoryEquipmentIsSortedAsc: true,
    inventoryEquipmentTableFilterList: [],
    inventoryEquipmentTableFilterApply: false,
    formSubmitted: false,
    inventoryAllVendors: [],
    inventoryAllCircuitTypes: [],
    inventoryAllContracts: [],
    inventoryAllGlCodes: [],
    inventoryAllCostCenters: [],
    inventoryAllCompanyCodes: [],
    vendorPage: 1,
    hasMoreVendor: true,
    isVendorLoading: false,
    circuitTypePage: 1,
    hasMoreCircuitType: true,
    isCircuitTypeLoading: false,
    contractPage: 1,
    hasMoreContract: true,
    isContractLoading: false,
    glCodePage: 1,
    hasMoreGlCode: true,
    isGlCodeLoading: false,
    costCenterPage: 1,
    hasMoreCostCenter: true,
    isCostCenterLoading: false,
    companyCodePage: 1,
    hasMoreCompanyCode: true,
    isCompanyCodeLoading: false,
    inventoryEquipmentComments: [],   
    hasMoreComments: false,     
    commentsPage: 1,
    inventoryEquipmentDetails: {
        equipmentId : 0,
        equipmentTypeId: 0,
        model : "",
        productName: "",
        equipmentStatusId: 0,
        vendorId : 0,
        currency : "",
        circuitTypeId: 0,
        contractId : 0,
        orderCost : "0.00",
        discountedOrderCost : "0.00",
        mrc : "0.00",
        nrc : "0.00",
        glCodeId : 0,
        costCodeId: 0,
        companyCodeId : 0,
        isLoaded: false,
        vipId : 1,
    }
});

const initialState = defaultState();

export const inventoryEquipmentActions = {
    setDefaultInventoryEquipment: () => async (dispatch, state) => {
        dispatch({
            type: setDefaultInventoryEquipment,
            inventoryItems: DEFAULT_TABLE_RESULT_MODEL
        });
    },
    getInventoryEquipment: (pageIndex = 0, pageUnmount = false) => async (dispatch, state) => {
        const { Headers, Pagination } = state().inventoryEquipment.inventoryEquipmentItems;
        const { inventoryEquipmentIsSortedAsc,inventoryEquipmentTableFilterList, inventoryEquipmentTableFilterApply, inventoryEquipmentColSort } = state().inventoryEquipment;
        var data = {
            PageFilter: {
                PageIndex: pageIndex !== undefined ? pageIndex : 0,
                PageSize: Pagination.PerPage,
                PageSizes: Pagination.PageSizes
            },
            Eid: JSON.parse(sessionStorage.getItem('User')).Employee.EnterpriseId,
            UserId: sessionStorage.getItem('UserID'),
            EmployeeId: sessionStorage.getItem('EmployeeID'),
            Headers: pageUnmount? {} : {
                ...Headers
            },
            SortedColumnName: inventoryEquipmentColSort,
            IsSortAscending: inventoryEquipmentIsSortedAsc,
            TableFilterList: inventoryEquipmentTableFilterList,
            ApplyFilter: inventoryEquipmentTableFilterApply
        };

        var inventoryItems = await httpPost('external/inventory/getEquipmentItems', data);
        if (inventoryItems.ok === false) {
            dispatch({
                type: setInventoryEquipmentError,
                isInventoryEquipmentError: true,
                isInventoryEquipmentLoaded: false
            });
        } else {
            dispatch({
                type: getInventoryEquipment,
                inventoryItems: Object.keys(inventoryItems).length > 0 ? inventoryItems : DEFAULT_TABLE_RESULT_MODEL,
                isInventoryEquipmentLoaded: true,
                isInventoryEquipmentError: false
            });
        }
    },
    setResetSearch: () => async (dispatch, state) => {
        
        const { inventoryEquipmentItems } = state().inventoryEquipment;
        var inventoryEquipmentItemsUpd = {
            ...inventoryEquipmentItems,
            "Headers": {}
        }

        dispatch({
            type: setInventoryEquipmentColSearchStr,
            data: inventoryEquipmentItemsUpd,
            isInventoryEquipmentError: false,
            isInventoryEquipmentLoaded: false
        });
    },
    setInventoryEquipmentColSearchStr: (event, key) => async (dispatch, state) => {
        var val = event.target.value;
        const { inventoryEquipmentItems } = state().inventoryEquipment;
        var inventoryEquipmentItemsUpd = {
            ...inventoryEquipmentItems,
            "Headers": {
                ...inventoryEquipmentItems.Headers,
                [key]: {

                    ...inventoryEquipmentItems.Headers[key],
                    searchString: val
                }
            }
        }

        dispatch({
            type: setInventoryEquipmentColSearchStr,
            data: inventoryEquipmentItemsUpd,
            isInventoryEquipmentError: false,
            isInventoryEquipmentLoaded: true
        });
    },
    sortInventoryEquipmentItems: (columnClicked, isSortedAsc) => async (dispatch, state) => {
        const { PageNumber, PageSizes } = state().inventoryEquipment.inventoryEquipmentItems.Pagination;
        const { inventoryEquipmentItems, inventoryEquipmentTableFilterList, inventoryEquipmentTableFilterApply } = state().inventoryEquipment;
        var data = {
            PageFilter: {
                PageIndex: PageNumber !== undefined ? PageNumber : 0,
                PageSize: inventoryEquipmentItems.Pagination.PerPage,
                PageSizes: PageSizes
            },
            Eid: JSON.parse(sessionStorage.getItem('User')).Employee.EnterpriseId,
            UserId: sessionStorage.getItem('UserID'),
            EmployeeId: sessionStorage.getItem('EmployeeID'),
            Headers: {
                ...inventoryEquipmentItems.Headers
            },
            SortedColumnName: columnClicked,
            IsSortAscending: isSortedAsc,
            TableFilterList: inventoryEquipmentTableFilterList,
            ApplyFilter: inventoryEquipmentTableFilterApply
        };
        var resInventoryEquipmentItems = await httpPost('external/inventory/getEquipmentItems', data);
        if (resInventoryEquipmentItems.ok === false) {
            dispatch({
                type: setInventoryEquipmentError,
                isInventoryEquipmentError: true,
                isInventoryEquipmentLoaded: false
            });
        } else {
            dispatch({
                type: sortInventoryEquipmentItems,
                inventoryEquipmentItems: Object.keys(resInventoryEquipmentItems).length > 0 ? resInventoryEquipmentItems : DEFAULT_TABLE_RESULT_MODEL,
                inventoryEquipmentColSort: columnClicked,
                inventoryEquipmentIsSortedAsc: isSortedAsc,
                isInventoryEquipmentLoaded: true
            });
        }
    },

    resizeInventoryEquipmentPage: (pageSize) => async (dispatch, state) => {
        dispatch({
            type: setInventoryEquipmentPageSize,
            pageSize: parseInt(pageSize),
        });
    },

    extractInventoryEquipments: () => async (dispatch, state) => {
        const { Headers } = state().inventoryEquipment.inventoryEquipmentItems;
        const { inventoryEquipmentIsSortedAsc, inventoryEquipmentTableFilterList, inventoryEquipmentTableFilterApply, inventoryEquipmentColSort } = state().inventoryEquipment;
        const dealName = sessionStorage.getItem('DealName');
        const { activeDateFormat, activeTimeZoneOffset } = state().adminSetting;
        const formattedTimeZoneDate = convertToFormatTimeZoneDate(
            new Date(),
            activeDateFormat?.Name || "YYYY-MM-DD",
            activeTimeZoneOffset?.UtcOffset || 0)
            .replace(/[<>:"/\|?*]/g, '-');
        const filename = `ATEM ${dealName} Equipment Extract – ${formattedTimeZoneDate}`;

        var data = {
            Eid: JSON.parse(sessionStorage.getItem('User')).Employee.EnterpriseId,
            UserId: sessionStorage.getItem('UserID'),
            EmployeeId: sessionStorage.getItem('EmployeeID'),
            Headers: {
                ...Headers
            },
            SortedColumnName: inventoryEquipmentColSort,
            IsSortAscending: inventoryEquipmentIsSortedAsc,
            FileName: filename,
            TableFilterList: inventoryEquipmentTableFilterList,
            ApplyFilter: inventoryEquipmentTableFilterApply
        };

        httpDownload('external/inventory/getExtractEquipment', data)
            .then(function (response) {
                return response.blob();
            })
            .then(function (blob) {
                let downloadUrl = window.URL.createObjectURL(blob);
                //Hide Loading
                let a = document.createElement('a');
                if (window.navigator.msSaveOrOpenBlob) {
                    window.navigator.msSaveOrOpenBlob(blob, filename);
                } else if (typeof a.download === 'undefined') {
                    window.location = downloadUrl;
                } else {
                    a.href = downloadUrl;
                    a.download = filename + '.xlsx';
                    document.body.appendChild(a);
                    a.click();
                }
            });
    },

    addInventoryEquipmentFilter: (tableFilter) => (dispatch, state) => {
        const { inventoryEquipmentTableFilterList } = state().inventoryEquipment;
        var filterList = [...inventoryEquipmentTableFilterList, tableFilter];

        dispatch({
            type: setInventoryEquipmentFilter,
            filterList: filterList
        })
    },

    removeInventoryEquipmentFilter: (removeIndex) => (dispatch, state) => {
        const { inventoryEquipmentTableFilterList } = state().inventoryEquipment;

        var filterList = inventoryEquipmentTableFilterList.filter((item, index) => {
            return index !== removeIndex;
        });

        dispatch({
            type: setInventoryEquipmentFilter,
            filterList: filterList
        })
    },

    applyInventoryEquipmentFilter: (isApply) => (dispatch, state) => {
        const { inventoryEquipmentTableFilterList } = state().inventoryEquipment;

        dispatch({
            type: applyInventoryEquipmentFilter,
            applyFilter: isApply,
            filterList: isApply ? inventoryEquipmentTableFilterList : []
        });
    },

    submitRequest: () => async (dispatch, state) => {
        const { inventoryEquipmentForm } = state().form;
        const { inventoryEquipmentDropdownList, inventoryAllCompanyCodes, inventoryAllCostCenters, inventoryAllGlCodes } = state().inventoryEquipment;

        let isVipUser = !isNaN(parseInt(inventoryEquipmentForm.vipId)) && parseInt(inventoryEquipmentForm.vipId) > 0
            ? inventoryEquipmentDropdownList.IsVIPOption.find(s => s.Key === parseInt(inventoryEquipmentForm.vipId)).Value
            : null;
        let glCodeId = !isNaN(parseInt(inventoryEquipmentForm.glCodeId)) && inventoryEquipmentForm.glCodeId > 0
            ? inventoryAllGlCodes?.find(s => s.Key === inventoryEquipmentForm.glCodeId).Label
            : null;
        const costCodeId =
            !isNaN(parseInt(inventoryEquipmentForm.costCodeId)) &&
                parseInt(inventoryEquipmentForm.costCodeId) > 0
                ? parseInt(inventoryEquipmentForm.costCodeId)
                : null;
        const costCenterOption = costCodeId
            ? inventoryAllCostCenters?.find(c => c.Key === costCodeId)
            : null;
        const cost1 = costCenterOption?.Value?.split("~")[1] ?? "";
        const companyCodeOption = inventoryAllCompanyCodes?.find(
            c => c.Key === parseInt(inventoryEquipmentForm.companyCodeId)
        );
        const companyCode =
            !isNaN(parseInt(inventoryEquipmentForm.companyCodeId)) &&
                parseInt(inventoryEquipmentForm.companyCodeId) > 0
                ? costCodeId &&
                    cost1 !== "" &&
                    cost1 !== companyCodeOption?.Value
                    ? null
                    : companyCodeOption?.Value ?? null
                : null;
        var data = {
            EquipmentId: inventoryEquipmentForm.equipmentId,
            EquipmentTypeId: inventoryEquipmentForm.equipmentTypeId,
            Model: inventoryEquipmentForm.model,
            ProductName: inventoryEquipmentForm.productName,
            EquipmentStatusID: !isNaN(parseInt(inventoryEquipmentForm.equipmentStatusId)) ? parseInt(inventoryEquipmentForm.equipmentStatusId) : 0,
            VendorId: inventoryEquipmentForm.vendorId,
            CircuitTypeId: inventoryEquipmentForm.circuitTypeId,
            ContractId: inventoryEquipmentForm.contractId,
            Cost: isNaN(parseFloat(inventoryEquipmentForm.orderCost)) ? 0 : inventoryEquipmentForm.orderCost,
            DiscountedOrderCost: isNaN(parseInt(inventoryEquipmentForm.discountedOrderCost)) ? 0 : inventoryEquipmentForm.discountedOrderCost,
            MRC: isNaN(parseInt(inventoryEquipmentForm.mrc)) ? 0 : inventoryEquipmentForm.mrc,
            NRC: isNaN(parseInt(inventoryEquipmentForm.nrc)) ? 0 : inventoryEquipmentForm.nrc,
            GlCodeId: glCodeId,
            CostcodeID: costCodeId,
            CompanyCode: companyCode,
            IsVipUser: isVipUser,
            UserID: sessionStorage.getItem('UserID')
        }

        var res = await httpPost('external/inventory/saveInventoryEquipment', data);

        if (!(res.Success)) {
            dispatch({ type: setFormSubmitted, data: false });
        }
        return res;
    },

    getNewEquipmentInventoryForm:() => (dispatch, state) => {
        const { inventoryEquipmentDropdownList, inventoryAllCompanyCodes, inventoryAllGlCodes } = state().inventoryEquipment;
        var initialEquipmentDetail = JSON.parse(JSON.stringify(initialState.inventoryEquipmentDetails));
        setEquipmentInventoryForm(dispatch, inventoryEquipmentDropdownList, inventoryAllCompanyCodes, inventoryAllGlCodes, initialEquipmentDetail, undefined);
    },

    equipmentIsLoaded: () => async (dispatch) => {
        dispatch(actions.change('inventoryEquipmentForm.isLoaded', true));
    },

    equipmentIsNotLoaded: () => async (dispatch) => {
        dispatch(actions.change('inventoryEquipmentForm.isLoaded', false));
    },

    selectedCostCenter: (selectedKey) => async (dispatch) => {
        dispatch(actions.change('inventoryEquipmentForm.costCodeId', selectedKey));
        dispatch(actions.change('inventoryEquipmentForm.companyCodeId', 0));
    },

    selectedVendor: (selectedKey) => async (dispatch) => {
        dispatch(actions.change('inventoryEquipmentForm.vendorId', selectedKey));
        dispatch(actions.change('inventoryEquipmentForm.contractId', null));

        if (selectedKey && !isNaN(selectedKey)) {
            try {
                const res = await httpGet(`external/inventory/getSelectedCurrencyByVendor/${selectedKey}`);

                if (res) {
                    dispatch(actions.change('inventoryEquipmentForm.currency', res));
                } else {
                    dispatch(actions.change('inventoryEquipmentForm.currency', ''));
                }
            } catch (error) {
                dispatch(actions.change('inventoryEquipmentForm.currency', ''));
            }
        } else {
            dispatch(actions.change('inventoryEquipmentForm.currency', ''));
        }
    },

    getInventoryEquipmentDetailsById: (equipmentId) => async (dispatch, state) => {
        const { inventoryEquipmentDropdownList, inventoryAllCompanyCodes, inventoryAllGlCodes } = state().inventoryEquipment;
        var initialEquipmentDetail = JSON.parse(JSON.stringify(initialState.inventoryEquipmentDetails));
        dispatch(actions.change('inventoryEquipmentForm.isLoaded', false));
        var equipmentDetail = await httpGet('external/inventory/getInventoryEquipmentDetails/' + equipmentId);
        if(equipmentDetail !== null){
            setEquipmentInventoryForm(dispatch, inventoryEquipmentDropdownList, inventoryAllCompanyCodes, inventoryAllGlCodes, initialEquipmentDetail, equipmentDetail);
            dispatch(actions.change('inventoryEquipmentForm.isLoaded', true));
        }
        else{
            dispatch(actions.change('inventoryEquipmentForm.isLoaded', false));
            dispatch(actions.reset('inventoryEquipmentForm'));
            dispatch(actions.change('inventoryEquipmentForm.mrc', 0.00));    
            dispatch(actions.change('inventoryEquipmentForm.discountedOrderCost', 0.00));    
            dispatch(actions.change('inventoryEquipmentForm.nrc', 0.00));    
            dispatch(actions.change('inventoryEquipmentForm.orderCost', 0.00));    
            dispatch({
                type: setInventoryEquipmentError,
                isInventoryEquipmentError: true,
            });
        }
    },

    getEquipmentdropDownList: () => async (dispatch, state) => {
        var res = await httpGet('external/inventory/getInventoriesEquipmentDropdownList');
        if (res != null)
        {
            dispatch({
                type: getEquipmentdropDownList,
                isEquipmentdropDownListLoaded: true,
                inventoryEquipmentDropDownList: Object.keys(res).length > 0 ? res : DEFAULT_TABLE_RESULT_EQUIPMENT_DROPDOWN_MODEL,
            });
        }
        else{
            dispatch({
                type: setInventoryEquipmentError,
                isEquipmentdropDownListLoaded : false,
                isInventoryEquipmentError: true,
            });  
        }
    },
    resetEquipmentComments: () => (dispatch) => {
        dispatch({
            type: resetEquipmentComments,
        })
    },

    getInventoryEquipmentComments: (equipmentID, pageIndex = 1, pageSize = 5) => async (dispatch, state) => {
        const existingComments = state().inventoryEquipment?.inventoryEquipmentComments || [];
        const lastCommentId = existingComments.length > 0
            ? existingComments[existingComments.length - 1].CommentID
            : null;

        const url = `external/inventoryManager/getEquipmentComments/${pageIndex}/${pageSize}?equipmentID=${equipmentID}`
            + (lastCommentId ? `&lastCommentId=${lastCommentId}` : "");

        const res = await httpGet(url);

        if (res != null) {
            dispatch({
                type: getInventoryEquipmentComments,
                inventoryEquipmentComments: res.equipmentComments,
                isInventoryEquipmentLoaded: true,
                isInventoryEquipmentError: false,
                commentsPage: pageIndex,
                hasMoreData: res.hasMoreData
            });
        } else {
            dispatch({
                type: setInventoryEquipmentError,
                isInventoryEquipmentError: true,
                isInventoryEquipmentLoaded: false
            });
        }
    },
    postInventoryEquipmentComments: (equipmentID, filename, fileData, comment) => async (dispatch, state) => {
        var formData = new FormData();

        if (fileData.length > 0) {
            fileData.forEach((element) => formData.append("FileData", element));
            formData.append("FileName", JSON.stringify(filename));
        }

        formData.append("Comment", comment.toString());
        formData.append("UserId", parseInt(sessionStorage.getItem('UserID')),);
        formData.append("EquipmentID", equipmentID);

        var res = await httpPostFile('external/inventoryManager/setEquipmentComments', formData);

        if (res != null) {

            dispatch({
                type: insertEquipmentComments,
                inventoryEquipmentComments: [res?.equipmentComments[0]],
                isInventoryEquipmentLoaded: true,
                isInventoryEquipmentError: false
            });
        } else {
            dispatch({
                type: setInventoryEquipmentError,
                isInventoryEquipmentError: true,
                isInventoryEquipmentLoaded: false
            });
        }
    },
    saveInventoryEquipmentCustomCols: (selectedCols) => async (dispatch, state) => {
        const { Headers, Pagination } = state().inventoryEquipment.inventoryEquipmentItems;
        const { inventoryEquipmentIsSortedAsc, inventoryEquipmentColSort, inventoryEquipmentTableFilterList, inventoryEquipmentTableFilterApply } = state().inventoryEquipment;

        try {
            var userId = sessionStorage.getItem('UserID');
            var customizeFormData = {
                UserId: parseInt(userId),
                ReportColumnModule: REPORT_COLUMN_MODULE.EquipmentInventoryManagement,
                SelectedCols: selectedCols
            };

            await httpPost('external/inventory/saveCustomizeColumns', customizeFormData);

            dispatch({
                type: setInventoryEquipmentError,
                isInventoryEquipmentError: false,
                isInventoryEquipmentLoaded: false
            });

            var data = {
                PageFilter: {
                    PageIndex: 0,
                    PageSize: Pagination.PerPage,
                    PageSizes: Pagination.PageSizes
                },

                Eid: JSON.parse(sessionStorage.getItem('User')).Employee.EnterpriseId,
                UserId: userId,
                EmployeeId: sessionStorage.getItem('EmployeeID'),
                Headers: {
                    ...Headers
                },
                SortedColumnName: inventoryEquipmentColSort,
                IsSortAscending: inventoryEquipmentIsSortedAsc,
                TableFilterList: inventoryEquipmentTableFilterList,
                ApplyFilter: inventoryEquipmentTableFilterApply
            };

            var inventoryItems = await httpPost('external/inventory/getEquipmentItems', data);

            dispatch({
                type: getInventoryEquipment,
                inventoryItems: Object.keys(inventoryItems).length > 0 ? inventoryItems : DEFAULT_TABLE_RESULT_MODEL,
                isInventoryEquipmentLoaded: true,
                isInventoryEquipmentError: false
            });
        }
        catch (e) {
            dispatch({
                type: setInventoryEquipmentError,
                isInventoryEquipmentError: true,
                isInventoryEquipmentLoaded: false
            });
        }
    },

    deleteInventoryEquipmentComments: (commentId) => async (dispatch, state) => {
        var userId = sessionStorage.getItem("UserID")
        var res = await httpPost(`external/inventoryManager/equipmentInventoryDeleteComment/${commentId}/${userId}`);

        if (res == null) {
            dispatch({
                type: setInventoryEquipmentError,
                isInventoryEquipmentError: true,
                isInventoryEquipmentLoaded: false
            });
        }
    },

    getAllVendors: (page = 1, searchString = '') => async (dispatch, state) => {
        const pageSize = 15;
        dispatch({ type: setVendorsLoading, payload: true });

        let url = `external/inventory/getAllVendors/${page}/${pageSize}`;
        if (searchString) url += `?searchString=${encodeURIComponent(searchString)}`;

        try {
            const res = await httpGet(url);
            if (res != null) {
                dispatch({
                    type: getAllVendors,
                    payload: { vendors: res, vendorPage: page, pageSize }
                });
            } else {
                dispatch({
                    type: setEquipmentDropdownError,
                    isEquipmentDropdownError: true,
                    isEquipmentDropdownLoaded: false
                });
            }
        } catch {
            dispatch({
                type: setEquipmentDropdownError,
                isEquipmentDropdownError: true,
                isEquipmentDropdownLoaded: false
            });
        } finally {
            dispatch({ type: setVendorsLoading, payload: false });
        }
    },

    getAllCircuitTypes: (page = 1, searchString = '') => async (dispatch, state) => {
        const pageSize = 15;
        dispatch({ type: setCircuitTypeLoading, payload: true });

        let url = `external/inventory/getInventoryAllCircuitTypes/${page}/${pageSize}`;
        if (searchString) url += `?searchString=${encodeURIComponent(searchString)}`;

        try {
            const res = await httpGet(url);
            if (res != null) {
                dispatch({
                    type: getAllCircuitTypes,
                    payload: { circuitTypes: res, circuitTypePage: page, pageSize }
                });
            } else {
                dispatch({
                    type: setEquipmentDropdownError,
                    isEquipmentDropdownError: true,
                    isEquipmentDropdownLoaded: false
                });
            }
        } catch {
            dispatch({
                type: setEquipmentDropdownError,
                isEquipmentDropdownError: true,
                isEquipmentDropdownLoaded: false
            });
        } finally {
            dispatch({ type: setCircuitTypeLoading, payload: false });
        }
    },

    getAllContracts: (vendorId, page = 1, searchString = '') => async (dispatch, state) => {
        const pageSize = 15;
        dispatch({ type: setContractsLoading, payload: true });

        const safeVendorId = vendorId ? parseInt(vendorId) : 0;

        let url = `external/inventory/getAllContracts/${safeVendorId}/${page}/${pageSize}`;
        if (searchString) url += `?searchString=${encodeURIComponent(searchString)}`;

        try {
            const res = await httpGet(url);
            if (res != null) {
                dispatch({
                    type: getAllContracts,
                    payload: { contracts: res, contractPage: page, pageSize }
                });
            } else {
                dispatch({
                    type: setEquipmentDropdownError,
                    isEquipmentDropdownError: true,
                    isEquipmentDropdownLoaded: false
                });
            }
        } catch {
            dispatch({
                type: setEquipmentDropdownError,
                isEquipmentDropdownError: true,
                isEquipmentDropdownLoaded: false
            });
        } finally {
            dispatch({ type: setContractsLoading, payload: false });
        }
    },

    getAllGlCodes: (page = 1, searchString = '') => async (dispatch, state) => {
        const pageSize = 15;
        dispatch({ type: setGlCodesLoading, payload: true });

        let url = `external/inventory/getAllGlCodes/${page}/${pageSize}`;
        if (searchString) url += `?searchString=${encodeURIComponent(searchString)}`;

        try {
            const res = await httpGet(url);
            if (res != null) {
                dispatch({
                    type: getAllGlCodes,
                    payload: { glCodes: res, glCodePage: page, pageSize }
                });
            } else {
                dispatch({
                    type: setEquipmentDropdownError,
                    isEquipmentDropdownError: true,
                    isEquipmentDropdownLoaded: false
                });
            }
        } catch {
            dispatch({
                type: setEquipmentDropdownError,
                isEquipmentDropdownError: true,
                isEquipmentDropdownLoaded: false
            });
        } finally {
            dispatch({ type: setGlCodesLoading, payload: false });
        }
    },

    getAllCostCenters: (page = 1, searchString = '') => async (dispatch, state) => {
        const pageSize = 15;
        dispatch({ type: setCostCentersLoading, payload: true });

        let url = `external/inventory/getAllCostCenters/${page}/${pageSize}`;
        if (searchString) url += `?searchString=${encodeURIComponent(searchString)}`;

        try {
            const res = await httpGet(url);
            if (res != null) {
                dispatch({
                    type: getAllCostCenters,
                    payload: { costCenters: res, costCenterPage: page, pageSize }
                });
            } else {
                dispatch({
                    type: setEquipmentDropdownError,
                    isEquipmentDropdownError: true,
                    isEquipmentDropdownLoaded: false
                });
            }
        } catch {
            dispatch({
                type: setEquipmentDropdownError,
                isEquipmentDropdownError: true,
                isEquipmentDropdownLoaded: false
            });
        } finally {
            dispatch({ type: setCostCentersLoading, payload: false });
        }
    },

    getAllCompanyCodes: (costCodeId, page = 1, searchString = '') => async (dispatch, state) => {
        const pageSize = 15;
        dispatch({ type: setCompanyCodesLoading, payload: true });

        const safeCostCodeId = costCodeId ? parseInt(costCodeId) : 0;

        let url = `external/inventory/getAllCompanyCodes/${safeCostCodeId}/${page}/${pageSize}`;
        if (searchString) url += `?searchString=${encodeURIComponent(searchString)}`;

        try {
            const res = await httpGet(url);
            if (res != null) {
                dispatch({
                    type: getAllCompanyCodes,
                    payload: { companyCodes: res, companyCodePage: page, pageSize }
                });
            } else {
                dispatch({
                    type: setEquipmentDropdownError,
                    isEquipmentDropdownError: true,
                    isEquipmentDropdownLoaded: false
                });
            }
        } catch {
            dispatch({
                type: setEquipmentDropdownError,
                isEquipmentDropdownError: true,
                isEquipmentDropdownLoaded: false
            });
        } finally {
            dispatch({ type: setCompanyCodesLoading, payload: false });
        }
    },

    checkDuplicate: () => async (dispatch, state) => {
        const { inventoryEquipmentForm } = state().form;   
        var data = {
            EquipmentId: inventoryEquipmentForm.equipmentId,
            Model: inventoryEquipmentForm.model,
            EquipmentTypeId: inventoryEquipmentForm.equipmentTypeId,
            VendorId: inventoryEquipmentForm.vendorId
        }
        var res = await httpPost('external/inventory/checkDuplicateEquipmentItem', data);
        return res;
    },

    resetEquipmentForm: () => async (dispatch) => {    
        dispatch(actions.reset('inventoryEquipmentForm'));
    },

    resetInventoryEquipmentData: () => async (dispatch) => {
        dispatch({ type: resetInventoryEquipmentData, data: DEFAULT_TABLE_RESULT_MODEL });
    },
}; 

function setEquipmentInventoryForm(dispatch, inventoryEquipmentDropdownList, inventoryAllCompanyCodes, inventoryAllGlCodes, initialEquipmentDetail, equipmentDetail) {
    var inventoryEquipmentDetails = JSON.parse(JSON.stringify(initialEquipmentDetail));
    if(equipmentDetail !== undefined){
        inventoryEquipmentDetails.equipmentId = equipmentDetail.EquipmentId;
        inventoryEquipmentDetails.equipmentTypeId = equipmentDetail.EquipmentTypeId;
        inventoryEquipmentDetails.model = equipmentDetail.Model;
        inventoryEquipmentDetails.productName = equipmentDetail.ProductName;
        inventoryEquipmentDetails.equipmentStatusId = equipmentDetail.EquipmentStatusID === null
        ? 0
        : parseInt(equipmentDetail.EquipmentStatusID);
        inventoryEquipmentDetails.vendorId = equipmentDetail.VendorId;
        inventoryEquipmentDetails.currency = equipmentDetail.Currency;
        inventoryEquipmentDetails.circuitTypeId = equipmentDetail.CircuitTypeId === null ? 0 : equipmentDetail.CircuitTypeId;
        inventoryEquipmentDetails.contractId = equipmentDetail.ContractId;
        const isVip = equipmentDetail.IsVipUser;
        inventoryEquipmentDetails.vipId = isVip === null || isVip === ""
            ? 0
            : !isNaN(parseInt(isVip))
                ? parseInt(isVip)
                : (inventoryEquipmentDropdownList.IsVIPOption.find(
                    s => s.Value?.toUpperCase() === isVip?.toUpperCase()
                )?.Key || 0);
        inventoryEquipmentDetails.orderCost = equipmentDetail.Cost;
        inventoryEquipmentDetails.discountedOrderCost = equipmentDetail.DiscountedOrderCost;
        inventoryEquipmentDetails.mrc = equipmentDetail.MRC;
        inventoryEquipmentDetails.nrc = equipmentDetail.NRC;
        inventoryEquipmentDetails.glCodeId = !isNaN(parseInt(equipmentDetail.GlCodeId))
            ? inventoryAllGlCodes?.find(s => s.Label === equipmentDetail.GlCodeId).Key
            : 0;
         inventoryEquipmentDetails.costCodeId = equipmentDetail.CostcodeID;
        const companyCode = inventoryAllCompanyCodes?.find(
            c => c.Value === equipmentDetail.CompanyCode
        );
        inventoryEquipmentDetails.companyCodeId = companyCode ? companyCode.Key : 0;
    }
    dispatch(actions.reset('inventoryEquipmentForm'));
    dispatch(actions.change('inventoryEquipmentForm.equipmentId', inventoryEquipmentDetails.equipmentId));
    dispatch(actions.change('inventoryEquipmentForm.equipmentTypeId', inventoryEquipmentDetails.equipmentTypeId));
    dispatch(actions.change('inventoryEquipmentForm.model', inventoryEquipmentDetails.model));
    dispatch(actions.change('inventoryEquipmentForm.productName', inventoryEquipmentDetails.productName));
    dispatch(actions.change('inventoryEquipmentForm.equipmentStatusId', inventoryEquipmentDetails.equipmentStatusId));
    dispatch(actions.change('inventoryEquipmentForm.vendorId', inventoryEquipmentDetails.vendorId));
    dispatch(actions.change('inventoryEquipmentForm.currency', inventoryEquipmentDetails.currency));
    dispatch(actions.change('inventoryEquipmentForm.circuitTypeId', inventoryEquipmentDetails.circuitTypeId));
    dispatch(actions.change('inventoryEquipmentForm.contractId', inventoryEquipmentDetails.contractId));
    dispatch(actions.change('inventoryEquipmentForm.vipId', inventoryEquipmentDetails.vipId));
    dispatch(actions.change('inventoryEquipmentForm.orderCost', inventoryEquipmentDetails.orderCost ? inventoryEquipmentDetails.orderCost : 0.00));
    dispatch(actions.change('inventoryEquipmentForm.discountedOrderCost', inventoryEquipmentDetails.discountedOrderCost != null ? inventoryEquipmentDetails.discountedOrderCost : 0.00 ));
    dispatch(actions.change('inventoryEquipmentForm.mrc', inventoryEquipmentDetails.mrc != null ? inventoryEquipmentDetails.mrc : 0.00));
    dispatch(actions.change('inventoryEquipmentForm.nrc', inventoryEquipmentDetails.nrc != null ? inventoryEquipmentDetails.nrc : 0.00));
    dispatch(actions.change('inventoryEquipmentForm.glCodeId', inventoryEquipmentDetails.glCodeId));
    dispatch(actions.change('inventoryEquipmentForm.costCodeId', inventoryEquipmentDetails.costCodeId));
    dispatch(actions.change('inventoryEquipmentForm.companyCodeId', inventoryEquipmentDetails.companyCodeId));
    dispatch({
        type: getInventoryEquipmentDetailsById,
        inventoryEquipmentDetails: inventoryEquipmentDetails,
        isInventoryEquipmentError: false,

    });
}

export const reducer = (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case getInventoryEquipment:
            return {
                ...state,
                inventoryEquipmentItems: action.inventoryItems,
                isInventoryEquipmentLoaded: action.isInventoryEquipmentLoaded,
                isInventoryEquipmentError: action.isInventoryEquipmentError
            };

        case setInventoryEquipmentError:
            return {
                ...state,
                isInventoryEquipmentError: action.isInventoryEquipmentError,
                isInventoryEquipmentLoaded: action.isInventoryEquipmentLoaded
            };

        case getInventoryEquipmentComments:
            return {
                ...state,
                inventoryEquipmentComments: [
                    ...(state.inventoryEquipmentComments || []),
                    ...(action.inventoryEquipmentComments || [])
                ],
                hasMoreComments: action.hasMoreData,
                commentsPage: action.commentsPage
            };

        case insertEquipmentComments: {
            const combinedComments = [
                ...action.inventoryEquipmentComments,
                ...state.inventoryEquipmentComments
            ];
            const currentVisibleCount = state.inventoryEquipmentComments.length;
            const currentDisplayLimit = Math.ceil(currentVisibleCount / 5) * 5;
            const hasMore = combinedComments.length > currentDisplayLimit && combinedComments.length !== 1;
            let updatedComments;
            if (hasMore) {
                updatedComments = combinedComments.slice(0, -1);
            } else {
                updatedComments = combinedComments;
            }

            return {
                ...state,
                inventoryEquipmentComments: combinedComments.length === 1 ? action.inventoryEquipmentComments : updatedComments,
                hasMoreComments: hasMore,
            }
        }
        case resetEquipmentComments:
            return {
                ...state,
                inventoryEquipmentComments: [],
                hasMoreComments: false,
                commentsPage: 1
            }
        case setInventoryEquipmentColSearchStr:
            return {
                ...state,
                inventoryEquipmentItems: action.data,
                isInventoryEquipmentLoaded: action.isInventoryEquipmentLoaded,
                isInventoryEquipmentError: action.isInventoryEquipmentError
            };

        case sortInventoryEquipmentItems:
            return {
                ...state,
                inventoryEquipmentItems: action.inventoryEquipmentItems,
                inventoryEquipmentColSort: action.inventoryEquipmentColSort,
                inventoryEquipmentIsSortedAsc: action.inventoryEquipmentIsSortedAsc,
                isInventoryEquipmentLoaded: action.isInventoryEquipmentLoaded
            };

        case setInventoryEquipmentPageSize:
            return {
                ...state,
                inventoryEquipmentItems: {
                    ...state.inventoryEquipmentItems,
                    Pagination: {
                        ...state.inventoryEquipmentItems.Pagination,
                        PerPage: action.pageSize
                    }
                }
            };

        case setInventoryEquipmentFilter:
            return {
                ...state,
                inventoryEquipmentTableFilterList: action.filterList
            };

        case applyInventoryEquipmentFilter:
            return {
                ...state,
                inventoryEquipmentTableFilterApply: action.applyFilter,
                inventoryEquipmentTableFilterList: action.filterList
            };

        case getInventoryEquipmentDetailsById:
            return {
                ...state,
                inventoryEquipmentDetails: action.inventoryEquipmentDetails,
                isInventoryEquipmentLoaded: action.isInventoryEquipmentLoaded
            };

        case getAllVendors: {
            const { vendors, vendorPage, pageSize } = action.payload;
            return {
                ...state,
                inventoryAllVendors: vendorPage === 1 ? vendors : [...state.inventoryAllVendors, ...vendors],
                hasMoreVendor: vendors.length === pageSize,
                vendorPage
            };
        }
        case setVendorsLoading:
            return { ...state, isVendorLoading: action.payload };

        case getAllCircuitTypes: {
            const { circuitTypes, circuitTypePage, pageSize } = action.payload;
            return {
                ...state,
                inventoryAllCircuitTypes: circuitTypePage === 1 ? circuitTypes : [...state.inventoryAllCircuitTypes, ...circuitTypes],
                hasMoreCircuitType: circuitTypes.length === pageSize,
                circuitTypePage
            };
        }
        case setCircuitTypeLoading:
            return { ...state, isCircuitTypeLoading: action.payload };

        case getAllContracts: {
            const { contracts, contractPage, pageSize } = action.payload;
            return {
                ...state,
                inventoryAllContracts: contractPage === 1 ? contracts : [...state.inventoryAllContracts, ...contracts],
                hasMoreContract: contracts.length === pageSize,
                contractPage
            };
        }
        case setContractsLoading:
            return { ...state, isContractLoading: action.payload };

        case getAllGlCodes: {
            const { glCodes, glCodePage, pageSize } = action.payload;
            return {
                ...state,
                inventoryAllGlCodes: glCodePage === 1 ? glCodes : [...state.inventoryAllGlCodes, ...glCodes],
                hasMoreGlCode: glCodes.length === pageSize,
                glCodePage
            };
        }
        case setGlCodesLoading:
            return { ...state, isGlCodeLoading: action.payload };

        case getAllCostCenters: {
            const { costCenters, costCenterPage, pageSize } = action.payload;
            return {
                ...state,
                inventoryAllCostCenters: costCenterPage === 1 ? costCenters : [...state.inventoryAllCostCenters, ...costCenters],
                hasMoreCostCenter: costCenters.length === pageSize,
                costCenterPage
            };
        }
        case setCostCentersLoading:
            return { ...state, isCostCenterLoading: action.payload };

        case getAllCompanyCodes: {
            const { companyCodes, companyCodePage, pageSize } = action.payload;
            return {
                ...state,
                inventoryAllCompanyCodes: companyCodePage === 1 ? companyCodes : [...state.inventoryAllCompanyCodes, ...companyCodes],
                hasMoreCompanyCode: companyCodes.length === pageSize,
                companyCodePage
            };
        }
        case setCompanyCodesLoading:
            return { ...state, isCompanyCodeLoading: action.payload };


        case setFormSubmitted:
            return { ...state, formSubmitted: action.data };

        case getEquipmentdropDownList:
            return {
                ...state,
                inventoryEquipmentDropdownList: action.inventoryEquipmentDropDownList,
                isEquipmentdropDownListLoaded: action.isEquipmentdropDownListLoaded
            };

        case resetInventoryEquipmentData:
            return { ...state, inventoryEquipmentItems: action.data };

        default:
            return state;
    }
};